import Generic from '../views/Generic'
import Home from '../views/Home'
import Farm from '../views/Farm'
import BlogPost from '../views/BlogPost'

export const navItems = [
    // bakery
    {
        path: '/bakery',
        title: 'Bakery',
        component: Home,
        child: [
            {path: '/bakery/1', title: '1', component: Generic},
            {path: '/bakery/2', title: '2', component: Generic},
            {path: '/bakery/3', title: '3', component: Generic},
        ]
    },
    {
        path: '/fruit_and_vagatable',
        title: 'Fruite and Vegatable',
        component: Generic,
        child: [
            {path: '/fruit_and_vagatable/1', title: '1', component: Generic},
            {path: '/fruit_and_vagatable/2', title: '2', component: Generic},
            {path: '/fruit_and_vagatable/3', title: '3', component: Generic},
        ]
    },
    {
        path: '/farm',
        title: 'Farm',
        component: Farm,
        child: [
            {path: '/meat_and_fish/1', title: '1', component: Generic},
            {path: '/meat_and_fish/2', title: '2', component: Generic},
            {path: '/meat_and_fish/3', title: '3', component: Generic},
        ]
    },
    {
        path: '/drinks',
        title: 'Drinks',
        component: Generic,
        child: [
            {path: '/drinks/1', title: '1', component: Generic},
            {path: '/drinks/2', title: '2', component: Generic},
            {path: '/drinks/3', title: '3', component: Generic},
        ]
    },
    {
        path: '/kitchen',
        title: 'Kitchen',
        component: Generic,
        child: [
            {path: '/kitchen/1', title: '1', component: Generic},
            {path: '/kitchen/2', title: '2', component: Generic},
            {path: '/kitchen/3', title: '3', component: Generic},
        ]
    },
    {
        path: '/special_nutrition',
        title: 'Special nutrition',
        component: BlogPost,
        child: [
            {path: '/special_nutrition/1', title: '1', component: Generic},
            {path: '/special_nutrition/2', title: '2', component: Generic},
            {path: '/special_nutrition/3', title: '3', component: Generic},
        ]
    },
    {
        path: '/baby',
        title: 'Baby',
        component: Generic,
        child: [
            {path: '/baby/1', title: '1', component: Generic},
            {path: '/baby/2', title: '2', component: Generic},
            {path: '/baby/3', title: '3', component: Generic},
        ]
    },
    {
        path: '/pharmcy',
        title: 'Pharmcy',
        component: Generic,
        child: [
            {path: '/pharmcy/1', title: '1', component: Generic},
            {path: '/pharmcy/2', title: '2', component: Generic},
            {path: '/pharmcy/3', title: '3', component: Generic},
        ]
    }
]